export const PROFILE_REQUERIED_FIELDS = ['firstName', 'lastName', 'dob', 'gender'];

export const PROFILE_ADDRESS_REQUERIED_FIELDS = (userWithStateCountries: boolean = false) => {
  if (userWithStateCountries) {
    return ['country', 'state', 'city', 'address', 'zipCode'];
  }
  return ['country', 'city', 'address', 'zipCode'];
};

export const SECOND_TIME_FAST_DEP_SEGMENT = 'second_time_fast_deposit';
